import type { SVGProps } from 'react';
const SvgMinimize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#minimize_svg__a)">
      <path fill="currentColor" d="M6 19h12v2H6v-2Z" />
    </g>
    <defs>
      <clipPath id="minimize_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMinimize;
